var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenvung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/emoji-happy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emoji-happy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.44 2.08691H8.06C4.42 2.08691 2.25 4.25691 2.25 7.89691V16.2669C2.25 19.9169 4.42 22.0869 8.06 22.0869H16.43C20.07 22.0869 22.24 19.9169 22.24 16.2769V7.89691C22.25 4.25691 20.08 2.08691 16.44 2.08691ZM8.75 6.46691C9.78 6.46691 10.63 7.30691 10.63 8.34691C10.63 9.38691 9.79 10.2269 8.75 10.2269C7.71 10.2269 6.87 9.36691 6.87 8.33691C6.87 7.30691 7.72 6.46691 8.75 6.46691ZM12.25 19.1669C9.56 19.1669 7.37 16.9769 7.37 14.2869C7.37 13.5869 7.94 13.0069 8.64 13.0069H15.84C16.54 13.0069 17.11 13.5769 17.11 14.2869C17.13 16.9769 14.94 19.1669 12.25 19.1669ZM15.75 10.2069C14.72 10.2069 13.87 9.36691 13.87 8.32691C13.87 7.28691 14.71 6.44691 15.75 6.44691C16.79 6.44691 17.63 7.28691 17.63 8.32691C17.63 9.36691 16.78 10.2069 15.75 10.2069Z",
    fill: "#DB2929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenvung);
export default __webpack_public_path__ + "static/media/benvung.0c7a925b637b79a0c989c968f6921398.svg";
export { ForwardRef as ReactComponent };